module.exports = __webpack_public_path__ + "legal/clientapplicationform.586dd042.pdf";